import type {
  ListingsAPIResponseFacet,
  ListingsAPIResponseNumericFacetValue,
  ListingsAPIResponseTextFacetValue,
} from '@noths/polaris-client-listings-api';

import type { Facet, FacetOption } from 'src/redux/productsQuery/types/Facet';
import { getUpdatedOptionsForNumericFacet } from './getUpdatedOptionsForNumericFacet';
import { getUpdatedOptionsForTextFacet } from './getUpdatedOptionsForTextFacet';

export const adaptResponseFacetsToStore = (
  listingsFacets: ListingsAPIResponseFacet[],
  storeFacets: Facet[],
): Facet[] => {
  return storeFacets.reduce((facetsAcc, storeFacet) => {
    const listingsFacet = listingsFacets.find((facet) => facet.key === storeFacet.key);

    if (!listingsFacet) {
      return facetsAcc;
    }

    let options: FacetOption[] = [];

    if (storeFacet.valueType === 'numeric') {
      options = getUpdatedOptionsForNumericFacet(
        storeFacet,
        listingsFacet.values as ListingsAPIResponseNumericFacetValue[],
      );
    }

    if (storeFacet.valueType === 'text') {
      options = getUpdatedOptionsForTextFacet(
        storeFacet,
        listingsFacet.values as ListingsAPIResponseTextFacetValue[],
      );
    }

    facetsAcc.push({
      ...storeFacet,
      options,
    });

    return facetsAcc;
  }, [] as Facet[]);
};
